module.exports = __webpack_public_path__ + "static/media/tick-container.32c3ade5.svg";